(function () {
  'use strict';

  function getTrack(btn) {
    var sel = btn.getAttribute('data-carousel-target');
    if (!sel) return null;
    try {
      return document.querySelector(sel);
    } catch (e) {
      return null;
    }
  }

  function updateArrowState(btn, track) {
    if (!track) return;
    var maxScroll = track.scrollWidth - track.clientWidth;
    if (maxScroll <= 2) {
      btn.classList.add('carousel-arrow--hidden');
      return;
    }
    btn.classList.remove('carousel-arrow--hidden');
    var dir = parseInt(btn.getAttribute('data-dir'), 10);
    if (dir < 0) {
      btn.disabled = track.scrollLeft <= 2;
    } else {
      btn.disabled = track.scrollLeft >= maxScroll - 2;
    }
  }

  function wire(btn) {
    if (btn.dataset.carouselArrowWired === '1') return;
    var track = getTrack(btn);
    if (!track) return;
    btn.dataset.carouselArrowWired = '1';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var dir = parseInt(this.getAttribute('data-dir'), 10);
      var scrollAmt = track.clientWidth * 0.8;
      track.scrollBy({ left: dir * scrollAmt, behavior: 'smooth' });
    });

    var refresh = function () { updateArrowState(btn, track); };
    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  }

  function init() {
    document.querySelectorAll('.carousel-arrow').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
